import React from "react";
import { Modal as BootstrapModal, Button } from 'react-bootstrap';

const CustomModal = ({ show, handleClose, title, body, isQuestion = false, questionAction = () => {} }) => {
    return (
        <BootstrapModal show={show} onHide={handleClose}>
            <BootstrapModal.Header closeButton>
                <BootstrapModal.Title>{title}</BootstrapModal.Title>
            </BootstrapModal.Header>
            <BootstrapModal.Body>{body}</BootstrapModal.Body>
            <BootstrapModal.Footer>
                {
                    !isQuestion ? 
                    (
                        <Button variant="secondary" onClick={handleClose}>
                            Fechar
                        </Button>
                    ) : (
                        <>
                        <Button variant="secondary" onClick={handleClose}>
                            Não
                        </Button>
                        <Button variant="secondary" onClick={handleClose}>
                            Sim
                        </Button>
                        </>
                    )
                }
            </BootstrapModal.Footer>
        </BootstrapModal>
    );
}

export default CustomModal;
